import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft, AlertCircle } from "lucide-react";
import type { SecurityIssue } from "@/types/security";

interface IssueHeaderProps {
  issue: SecurityIssue;
}

export function IssueHeader({ issue }: IssueHeaderProps) {
  const navigate = useNavigate();

  return (
    <>
      <Button variant="ghost" onClick={() => navigate("/issues")} className="gap-2 w-fit -ml-2">
        <ArrowLeft className="h-4 w-4" />
        Back to Issues
      </Button>

      <div className="flex items-start gap-4">
        <div className="flex-shrink-0 w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center">
          <AlertCircle className="h-6 w-6 text-orange-600" />
        </div>
        <div className="flex-1">
          <h1 className="text-2xl font-bold mb-2">{issue.title}</h1>
          <div className="text-sm text-muted-foreground">Issue</div>
        </div>
      </div>
    </>
  );
}
